var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributeLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#EDFFF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50171 10V8C7.50171 7.33696 7.7651 6.70107 8.23394 6.23223C8.70278 5.76339 9.33867 5.5 10.0017 5.5C10.6648 5.5 11.3006 5.76339 11.7695 6.23223C12.2383 6.70107 12.5017 7.33696 12.5017 8V10M6.50171 10H13.5017C14.054 10 14.5017 10.4477 14.5017 11V14.5C14.5017 15.0523 14.054 15.5 13.5017 15.5H6.50171C5.94942 15.5 5.50171 15.0523 5.50171 14.5V11C5.50171 10.4477 5.94942 10 6.50171 10Z",
    stroke: "#008934",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeLock);
export default __webpack_public_path__ + "static/media/attribute_lock.2d4c3dbe8a2a9c68382e0c48b92c1307.svg";
export { ForwardRef as ReactComponent };